/*
  <ck-medidor>: la barra de dosis de la franja de gomitas. Mover la barra o tocar
  una parada marca con `.on` todo lo que lleva ese `data-paso` (foto, etiqueta,
  número, texto, botón y la rejilla de gomitas de esa dosis) y rellena la pista en lima.
*/
(() => {
  if (customElements.get('ck-medidor')) return;

  class CkMedidor extends HTMLElement {
    connectedCallback() {
      const regla = this.querySelector('input[type=range]');
      if (!regla) return;
      const paradas = [...this.querySelectorAll('.ck-medidor__paradas button')];
      const elige = (i) => {
        regla.value = i;
        this.style.setProperty('--i', i);
        (this.closest('.ck-gomitas') || this).querySelectorAll('[data-paso]').forEach((el) => el.classList.toggle('on', +el.dataset.paso === i));
        this.querySelectorAll('template[data-ck-foto-paso].on').forEach((t) => { const f = t.content.cloneNode(true); f.querySelectorAll('[data-paso]').forEach(el => el.classList.add('on')); t.replaceWith(f); });
        if (paradas[i]) regla.setAttribute('aria-valuetext', paradas[i].dataset.texto);
      };
      regla.addEventListener('input', () => elige(+regla.value));
      paradas.forEach((b, i) => b.addEventListener('click', () => elige(i)));
      elige(+regla.value);
    }
  }

  customElements.define('ck-medidor', CkMedidor);
})();
